var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.closeSidebarPanel}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-panel"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40af15bd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 653
// module chunks = 1